import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../../common/DesktopMenu/index";
import MobileMenu from "../../../../common/MobileMenu/index";
import useWindowSize from "../../../../common/windowSize";
import NewFooter from "../../../../common/NewFooter";
import BackButton from "../../../Products/BackButton";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getCookie } from "../../../../utils/cookie";
import { toast } from "react-toastify";
import { privateAPI } from "../../../../utils/api";
import { useTranslation } from "react-i18next";
import { Background } from "../../../../common/Faq/styles";
import { SettingsHeader, Title } from "../../styles";
import NoOrders from "./NoOrders";
import OrderDetails from "./OrderDetails";
import { OrderListWrapper } from "./styles";

const MyOrders = () => {
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [myOrders, setMyOrders] = useState([]);
  const [userID] = useState(getCookie("userId"));
  const { t } = useTranslation();

  const getUserById = async () => {
    setLoading(true);
    try {
      const response = await privateAPI.get(
        `/auth/bacchus/client/cart/order/${userID}`
      );
      setMyOrders(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getUserById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? (
        <MobileMenu single={true} />
      ) : (
        <DesktopMenu single={true} />
      )}
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel />
          <Title>{t("myOrders")}</Title>
        </SettingsHeader>
        <OrderListWrapper>
          {myOrders.length ? (
            myOrders.map((item) => (
              <OrderDetails order={item} key={item.orderDate} />
            ))
          ) : (
            <NoOrders />
          )}
        </OrderListWrapper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default MyOrders;
